import React from 'react';
import DropdownElement from '../DropdownElement';
const VariantOutOfStockDropdownElement = ({ hideOOS, nib, variant, labelNIB, labelOutOfStock, onClickChangeItemVariant, disabled, isDropDownItemsCenterAligned = false, notifyIfBackIcon, nibIconSize, notifyIfBack, onClickChangeItemVariantNIB, }) => {
    if (hideOOS && notifyIfBack !== 'pb')
        return null;
    return (React.createElement(DropdownElement, { variantCode: variant.code, isVariantSelected: variant.selected, value: variant.size.name, valueInfo: nib ? labelNIB : labelOutOfStock, data: variant.code, isDisabled: disabled, onClickChangeItemVariant: () => {
            onClickChangeItemVariant(variant.code);
        }, shouldNIB: nib, isOOS: !nib, nibOnClick: nib
            ? () => {
                onClickChangeItemVariantNIB(variant.code);
            }
            : undefined, isDropDownItemsCenterAligned: isDropDownItemsCenterAligned, notifyIfBackIcon: notifyIfBackIcon, nibIconSize: nibIconSize }));
};
export default VariantOutOfStockDropdownElement;
//# sourceMappingURL=VariantOutOfStockDropdownElement.js.map